import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Flex, Icon, SystemProps } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { usePostHog } from "posthog-js/react";
import { useForm } from "react-hook-form";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import * as Yup from "yup";

import { Cross } from "~components/common/Icons";
import { Text, Input } from "../../../../components";
import { useShopify } from "../../../../context";
import { showToast } from "../../../../lib";
import { Button } from "../../../common/Button";

const messages = defineMessages({
  askQuestion: "Stel een vraag",
  name: "Naam*",
  namePlaceholder: "Vul hier uw naam in",
  email: "E-mailadres*",
  emailPlaceholder: "Uw e-mailadres",
  bodyPlaceholder: "Stel hier uw vraag...",
  submit: "Vraag versturen",
});

const schema = Yup.object().shape({
  email: Yup.string().email().required().trim(),
  name: Yup.string().required().trim().min(2),
  body: Yup.string().required().trim(),
});

export const QuestionForm = ({
  productId,
  productTitle,
  close,
  ...props
}: {
  productId: string;
  close: () => void;
  productTitle: string;
} & SystemProps) => {
  const intl = useIntl();
  const { customer } = useShopify();
  const posthog = usePostHog();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<any>({
    resolver: yupResolver(schema),
  });
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const onSubmit = async (values) => {
    const { data } = await supabase
      .from("product_questions")
      .select("id")
      .order("id", { ascending: false })
      .limit(1);
    const id = data[0].id + 1;
    const { error } = await supabase.from("product_questions").insert({
      id,
      email: values.email,
      author: values.name,
      body: values.body,
      isPublished: false,
      productId,
      productName: productTitle,
      dateCreated: new Date(),
    });
    // posthog.capture("Clicked Questions Widget", { section: "question form" });
    if (!error) {
      reset();
      showToast("Question sent!", "success");
    }
  };
  return (
    <Box
      as="form"
      width="130%"
      p={2}
      bg={["#FCF9F7", "white"]}
      borderRadius="md"
      border="1px"
      borderColor="grey200"
      position={"relative"}
      onSubmit={handleSubmit(onSubmit)}
      {...props}
    >
      <Text fontSize={2.25} fontWeight={700} mb={"20px"} fontFamily={"DINPro"}>
        <FormattedMessage {...messages.askQuestion} />
      </Text>
      {!customer && (
        <Flex alignItems={"center"} mb="20px">
          <Text mr={"9px"}>Heb je een account?</Text>
          <Button
            as="a"
            href="/api/auth/login"
            width={100}
            py={"0 !important"}
            minHeight={44}
            lineHeight={1}
            px={"0 !important"}
            variant="secondary"
          >
            Log in
          </Button>
        </Flex>
      )}
      <Input
        label={intl.formatMessage(messages.name)}
        placeholder={intl.formatMessage(messages.namePlaceholder)}
        error={errors.name && String(errors?.name?.message)}
        {...register("name")}
        mb={3}
      />

      <Input
        type="email"
        label={intl.formatMessage(messages.email)}
        placeholder={intl.formatMessage(messages.emailPlaceholder)}
        error={errors.email && String(errors?.email?.message)}
        {...register("email")}
        mb={1.5}
      />

      <Input
        label="Vraag"
        as="textarea"
        rows={6}
        height={"160px"}
        placeholder={intl.formatMessage(messages.bodyPlaceholder)}
        error={errors.body && String(errors?.body?.message)}
        {...register("body")}
        mb={5}
      />

      <Button
        type="submit"
        variant="primary"
        width="100%"
        isLoading={isSubmitting}
        disabled={isSubmitting}
      >
        <FormattedMessage {...messages.submit} />
      </Button>
      <Icon
        onClick={close}
        cursor={"pointer"}
        top={2}
        right={2}
        fontSize={"20px"}
        color="black"
        position={"absolute"}
        icon={Cross}
      />
    </Box>
  );
};
